<button class="quote-cta-button" [ngClass]="'quote-cta-button__' + icon" type="button" (click)="buttonClicked.emit()"></button>
